import src from "IMAGE";
export default { src, width: 46, height: 66, blurWidth: 6, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAANElEQVR42p2MwQkAIAwD6xb5BH8ua8dyMM3HXyntQeDgIGYtxgPA1OQ/kFzb/WjyPIRXJS4qzQ092jkg8AAAAABJRU5ErkJggg=="};
